import { launchAchievementDefinitions } from './definitions/launch'
import type { BoggleAchievementDefinition, BoggleAchievementId } from './types'

export const BOGGLE_ACHIEVEMENT_DEFINITIONS: readonly BoggleAchievementDefinition[] =
  launchAchievementDefinitions

const BOGGLE_ACHIEVEMENT_REGISTRY = Object.fromEntries(
  BOGGLE_ACHIEVEMENT_DEFINITIONS.map(definition => [definition.id, definition]),
) as Record<BoggleAchievementId, BoggleAchievementDefinition>

export function getBoggleAchievementDefinition(achievementId: BoggleAchievementId) {
  return BOGGLE_ACHIEVEMENT_REGISTRY[achievementId]
}
